import React from "react";

const NewPollingCard = ({ data }) => {
  return (
    <div className="p-1 w-full h-fit flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-grayColor">
        New poll created
      </span>

      <div className="flex-col align-start justify-start g-05">
        <div
          className="flex-row align-start justify-start g-05 pb-1"
          style={{ borderBottom: "2px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">{data?.timestamp}</span>
        </div>
        <div
          className="flex-row align-center justify-start g-05 pb-1 pt-1"
          style={{ borderBottom: "2px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">Purpose:</span>
          <span className="poppins t-14 color-grayColor">{data?.purpose}</span>
        </div>
        <div className="flex-row align-center justify-start g-05 pb-1 pt-1">
          <span className="poppins t-14 color-black">End time:</span>
          <span className="poppins t-14 color-grayColor">{data?.endTime} </span>
        </div>

        <button type="button" className="actionBtn w-full">
          Vote now
        </button>
      </div>
    </div>
  );
};

export default NewPollingCard;
